import ProfileTagsList from './ProfileTagsList';

export default {
  list: ProfileTagsList,
};
